import styled from '@emotion/styled';
import { keyframes } from '@emotion/core';
import { Box } from '@qga/roo-ui/components';

const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

const Wrapper = styled(Box)`
  overflow: hidden;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Inner = styled.img<{ cover: boolean }>`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: ${(props) => (props.cover ? 'cover' : 'contain')};
  &[data-animate] {
    animation: ${fadeIn} 250ms;
  }
`;

interface ImageInnerProps {
  src: string;
  alt?: string;
  srcSet?: string;
  cover?: boolean;
  animate?: boolean;
  [key: string]: unknown;
}

export const ImageInner = ({
  src,
  srcSet,
  alt,
  cover = true,
  animate = false,
  ...rest
}: ImageInnerProps) => {
  return (
    <Wrapper data-testid="wrapper" {...rest}>
      <Inner
        src={src}
        srcSet={srcSet}
        alt={alt}
        cover={cover}
        data-animate={animate ? true : undefined}
        data-testid="image-inner"
      />
    </Wrapper>
  );
};
